import { Crown, Landmark, RefreshCw, Wifi, WifiOff } from 'lucide-react';
import { formatMoney } from '../utils/board.js';
import { TokenSprite } from './TokenSprite.jsx';

export function PlayersPanel({ game, viewerId, hostId }) {
  return (
    <section className="panel players-panel" aria-labelledby="players-heading">
      <header className="panel__header"><h2 id="players-heading">Игроки</h2><span>{game.players.filter((player) => !player.bankrupt).length} в игре</span></header>
      <div className="player-list">
        {game.players.map((player) => (
          <article className={`player-row ${game.currentPlayerId === player.id ? 'is-current' : ''} ${player.bankrupt ? 'is-bankrupt' : ''}`} key={player.id} style={{ '--player-color': player.color }}>
            <TokenSprite token={player.token} size="sm" />
            <div className="player-row__name">
              <strong>{player.name}{player.isBot ? ' · Бот' : player.id === viewerId ? ' (вы)' : ''}</strong>
              <span>{player.bankrupt ? 'Банкрот' : player.jail.inJail ? `В тюрьме · ${player.jail.turns}/3` : `${player.properties.length} объектов`}</span>
            </div>
            {player.id === hostId && <Crown size={15} aria-label="Хозяин комнаты" />}
            <span className={`player-connection player-connection--${player.connectionStatus ?? (player.connected ? 'online' : 'offline')}`}>
              {player.connectionStatus === 'reconnecting' ? <RefreshCw size={14} /> : player.connected ? <Wifi size={14} /> : <WifiOff size={14} />}
              {player.connectionStatus === 'reconnecting' ? 'Переподключение' : player.connected ? 'Онлайн' : 'Не в сети'}
            </span>
            <strong className="player-row__money"><Landmark size={14} />{formatMoney(player.money)}</strong>
          </article>
        ))}
      </div>
    </section>
  );
}
